import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const CommunityPlatformPage = lazy(() => import('./pages/CommunityPlatformPage'));
const SocialMonitoringPage = lazy(() => import('./pages/SocialMonitoringPage'));
const UserGeneratedContentPage = lazy(() => import('./pages/UserGeneratedContentPage'));
const EventsPage = lazy(() => import('./pages/EventsPage'));

export const CommunityRoutes: RouteObject = {
  path: 'community',
  element: <ModuleGuard moduleId="marketing.community" />,
  handle: { crumb: 'Social & Community' },
  children: [
    { index: true, element: <Navigate to="community-platform" replace /> },
    { path: 'community-platform', element: <CommunityPlatformPage />, handle: { crumb: 'Community Platform' } },
    { path: 'social-monitoring', element: <SocialMonitoringPage />, handle: { crumb: 'Social Monitoring' } },
    { path: 'user-generated-content', element: <UserGeneratedContentPage />, handle: { crumb: 'User Generated Content' } },
    { path: 'events', element: <EventsPage />, handle: { crumb: 'Events' } },
  ],
};
